@if (isOpen()) {
  <aside
    class="sidebar"
    [attr.dir]="language() === 'ar' ? 'rtl' : 'ltr'"
    role="dialog"
    aria-modal="true"
    [attr.aria-hidden]="!isOpen()"
  >
    <div class="sidebar__backdrop" (click)="onBackdropClick()"></div>
    <div class="sidebar__content">
      <div class="sidebar__header">
        <img
          src="/images/Logo.png"
          class="sidebar__logo"
          [alt]="'Header.LogoAlt' | translate"
          width="50"
          height="50"
        />
        <button
          type="button"
          (click)="onBackdropClick()"
          class="sidebar__close"
          [attr.aria-label]="'Header.CloseMenu' | translate"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
      </div>

      <nav class="sidebar__nav">
        <ul class="sidebar__menu">
          @for (item of navigationItems(); track item.translationKey) {
            @if (hasPermission()(item.requiredPermission || [])) {
              <li>
                @if (item.translationKey === 'Home.ProjectName') {
                  <button
                    type="button"
                    (click)="onToggleDropdown()"
                    class="sidebar__menu-item"
                  >
                    <span>{{ item.translationKey | translate }}</span>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      [class.sidebar__arrow--expanded]="isExpanded()"
                    >
                      <path
                        d="M6 9L12 15L18 9"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                  @if (isExpanded()) {
                    <ul class="sidebar__submenu">
                      @for (subItem of dropdownItems(); track subItem.translationKey) {
                        <li>
                          <a
                            [routerLink]="subItem.routerLink"
                            (click)="onLinkClick()"
                            class="sidebar__submenu-item"
                          >
                            {{ subItem.translationKey | translate }}
                          </a>
                        </li>
                      }
                    </ul>
                  }
                } @else {
                  <a
                    [routerLink]="item.routerLink"
                    (click)="onLinkClick()"
                    class="sidebar__menu-item"
                  >
                    {{ item.translationKey | translate }}
                  </a>
                }
              </li>
            }
          }
        </ul>
      </nav>

      <div class="sidebar__footer">
        @if (!isLoggedIn()) {
          <a
            [routerLink]="['/login']"
            (click)="onLinkClick()"
            class="sidebar__login"
          >
            <img
              src="images/Avatar.png"
              class="sidebar__avatar"
              [alt]="'Header.DefaultAvatarAlt' | translate"
              width="40"
              height="40"
            />
            <span>{{ "AUTH.LOGIN.LOGIN_BUTTON" | translate }}</span>
          </a>
        } @else {
          <div class="sidebar__user">
            <button
              type="button"
              (click)="onToggleUserMenu()"
              class="sidebar__menu-item"
            >
              <span class="sidebar__user-label">
                <img
                  [src]="userAvatar()"
                  class="sidebar__avatar"
                  [alt]="userName() || ('Header.DefaultAvatarAlt' | translate)"
                  width="40"
                  height="40"
                />
                <span>{{ userName() }}</span>
              </span>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                [class.sidebar__arrow--expanded]="showUserMenu()"
              >
                <path
                  d="M6 9L11.2929 14.2929C11.6262 14.6262 11.7929 14.7929 12 14.7929C12.2071 14.7929 12.3738 14.6262 12.7071 14.2929L18 9"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            @if (showUserMenu()) {
              <ul class="sidebar__submenu">
                <li>
                  <a
                    [routerLink]="['/profiles/user-profile']"
                    (click)="onCloseUserMenu(); onLinkClick()"
                    class="sidebar__submenu-item"
                  >
                    {{ "AUTH.USER_PROFILE" | translate }}
                  </a>
                </li>
                <li>
                  <button
                    type="button"
                    (click)="onLogout(); onLinkClick()"
                    class="sidebar__submenu-item"
                  >
                    {{ "AUTH.LOGOUT" | translate }}
                  </button>
                </li>
              </ul>
            }
          </div>
        }
        <button
          type="button"
          (click)="onChangeLanguage()"
          class="sidebar__language"
        >
          <svg width="23" height="22" viewBox="0 0 23 22" fill="none">
            <path
              d="M21.501 11C21.501 12.3133 21.2423 13.6137 20.7398 14.827C20.2372 16.0404 19.5006 17.1428 18.5719 18.0714C17.6433 19.0001 16.5408 19.7367 15.3275 20.2393C14.1142 20.7418 12.8138 21.0005 11.5005 21.0005C10.1872 21.0005 8.88679 20.7418 7.67347 20.2393C6.46016 19.7367 5.35771 19.0001 4.42908 18.0714C3.50045 17.1428 2.76381 16.0404 2.26124 14.827C1.75867 13.6137 1.5 12.3133 1.5 11C1.5 8.34771 2.55362 5.80405 4.42908 3.92859C6.30454 2.05313 8.8482 0.999512 11.5005 0.999512C14.1528 0.999512 16.6965 2.05313 18.5719 3.92859C20.4474 5.80405 21.501 8.34771 21.501 11Z"
              stroke="currentColor"
              stroke-width="1.5"
            />
            <path
              d="M15.5001 11C15.5001 12.313 15.3961 13.614 15.1951 14.827C14.9951 16.04 14.7001 17.142 14.3281 18.071C13.9571 19 13.5161 19.736 13.0311 20.239C12.5451 20.741 12.0251 21 11.5001 21C10.9751 21 10.4551 20.741 9.97006 20.239C9.48406 19.736 9.04305 18.999 8.67205 18.071C8.30005 17.142 8.00505 16.041 7.80405 14.827C7.59896 13.5617 7.49729 12.2818 7.50005 11C7.50005 9.687 7.60305 8.386 7.80405 7.173C8.00505 5.96 8.30005 4.858 8.67205 3.929C9.04305 3 9.48405 2.264 9.96905 1.761C10.4551 1.26 10.9751 1 11.5001 1C12.0251 1 12.5451 1.259 13.0301 1.761C13.5161 2.264 13.9571 3.001 14.3281 3.929C14.7001 4.858 14.9951 5.959 15.1951 7.173C15.3971 8.386 15.5001 9.687 15.5001 11Z"
              stroke="currentColor"
              stroke-width="1.5"
            />
            <path
              d="M1.5 11H21.5"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
            />
          </svg>
          <span>{{ 'Header.LanguageName' | translate }}</span>
        </button>
      </div>
    </div>
  </aside>
}
